import React from 'react';
import PropTypes from 'prop-types';

import {
    MessagePropType,
    LegacyCityPropType,
} from '@ratehub/base-ui';
import { PROVIDER_TYPES } from '@ratehub/mtg-common';

import useAllProviderRates from '../hooks/useAllProviderRates';
import PAGE_TEMPLATES from '../definitions/PageTemplates';
import { DEFAULT_MORTGAGE_CITY, DEFAULT_MORTGAGE_PROVINCE } from '../definitions/MortgageTerms';
import ProviderRatesPropType from '../definitions/ProviderRatesPropType';
import ProductTableMortgageProvider from './ProductTableMortgageProvider';


function ProductTableMortgageProviderRates({
    title,
    lastUpdatedDate,
    hideTimestamp,

    columns,

    initialBestRates,
    initialProviderRates,

    initialProvinceCode,
    initialCity,
    locationSelectorLabel,

    ctaLabel,
    ctaHREF,
    providerRateCTALabel,
    providerType,
    providers,

    className,
}) {
    const state = useAllProviderRates({
        columns,
        providerType,
        providers,

        initialProviderRates,
        initialBestRates,
        initialCity,
        initialProvinceCode,
    });

    return (
        <ProductTableMortgageProvider
            title={title}
            lastUpdatedDate={lastUpdatedDate}
            hideTimestamp={hideTimestamp}
            locationSelectorLabel={locationSelectorLabel}

            columnHeaders={columns}
            bestRates={state.bestRates}
            providerRates={state.providerRates}

            provinceCode={initialProvinceCode}
            city={initialCity}

            onChangeLocation={state.handleChangeLocation}

            ctaLabel={ctaLabel}
            ctaHREF={ctaHREF}
            providerRateCTALabel={providerRateCTALabel}

            isFetching={state.isFetching}

            className={className}
        />
    );
}

ProductTableMortgageProviderRates.propTypes = {
    title: PropTypes.string.isRequired,
    lastUpdatedDate: PropTypes.string.isRequired,
    hideTimestamp: PropTypes.bool,

    columns: PropTypes.arrayOf(PropTypes.shape({
        term: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        hiddenBelowWidth: PropTypes.bool,
    })).isRequired,

    initialBestRates: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number.isRequired,
        providerSlug: PropTypes.string.isRequired,
        deltaPrime: PropTypes.number,
    })),

    initialProviderRates: ProviderRatesPropType.isRequired,

    initialProvinceCode: PropTypes.string,
    initialCity: LegacyCityPropType,
    locationSelectorLabel: MessagePropType.isRequired,

    ctaLabel: MessagePropType.isRequired,
    ctaHREF: PropTypes.string.isRequired,
    providerRateCTALabel: MessagePropType.isRequired,
    providerType: PropTypes.oneOf(Object.values(PROVIDER_TYPES)),
    providers: PropTypes.arrayOf(PropTypes.string),

    className: PropTypes.string,
};

ProductTableMortgageProviderRates.defaultProps = {
    hideTimestamp: false,
    initialBestRates: undefined,
    initialProvinceCode: DEFAULT_MORTGAGE_PROVINCE,
    initialCity: DEFAULT_MORTGAGE_CITY,
    providerType: PROVIDER_TYPES.BIG_BANK,
    providers: undefined,

    className: undefined,
};

ProductTableMortgageProviderRates.blockKey = 'rh/product-table-mortgage-provider-rates';
ProductTableMortgageProviderRates.requiresLayoutRow = true;
ProductTableMortgageProviderRates.supportedPageTypes = [ PAGE_TEMPLATES.mortgages ];

export default ProductTableMortgageProviderRates;
